var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShelfBar = function SvgShelfBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 .6a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h15zm0 1.2H2a.8.8 0 0 0-.8.8v9a.8.8 0 0 0 .8.8h15a.8.8 0 0 0 .8-.8v-9a.8.8 0 0 0-.8-.8zm-2.4 5.8a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm-2 0a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm-2 0a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm-2 0a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm-2 0a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm-2 0a.6.6 0 0 1 .6.6v1.887a.6.6 0 0 1-1.2 0V8.2a.6.6 0 0 1 .6-.6zm10.017-4a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1 0-1.2h10.017z"
  })));
};

export default SvgShelfBar;